/**
 * "Uso de piscina" extra on a garden-face booking (line-item/uso-de-piscina).
 * Difference between pool and garden tiers × hours — charged to the guest.
 */
import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_POOL_USE_EXTRA, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const LineItemPoolUseExtraMaybe = props => {
  const { lineItems, intl } = props;

  const poolUseExtraLineItem = lineItems.find(
    item => item.code === LINE_ITEM_POOL_USE_EXTRA && !item.reversal
  );

  return poolUseExtraLineItem ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.poolUseExtra" />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, poolUseExtraLineItem.lineTotal)}</span>
    </div>
  ) : null;
};

LineItemPoolUseExtraMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemPoolUseExtraMaybe;
